import { Menu, Transition } from "@headlessui/react";
import Table from "../Table";
import { Link } from "react-router-dom";
import ProductContext from "../memory/ProductContext";
import Pagination from "../plugins/Pagination/paginationBar";
import "../styles/customTable.scss";
import { BiSort } from "react-icons/bi";

import { v4 as uuidv4 } from "uuid";
import FilteredDataProvider from "../plugins/Filters";
import ProductStatusToggle from "../plugins/ProductStatusToggle";
import { Button } from "../../../components/Button";
import EditPageButtonLink from "../plugins/EditPageButtonLink";
import DeletePopup from "../../../components/Popup/DeletePopup";
import ProductDeleteLink from "../../../components/Popup/DeleteLink";
import DeleteLink from "../../../components/Popup/DeleteLink";

class TransactionTable extends Table {
  tableSpacing: any = 50;
  tableColumnWidth: any = 250;
  finalSpacing: any = this.tableColumnWidth - this.tableSpacing;

  customSizes?: any = {
    "Date & Time": 200,
    Refund: 30,
    Source: 100,
    Amount: 100,
    "Transaction No": 100,
  };

  constructor(props: any) {
    super(props);
    this.stylingTableComp = "table-auto w-full text-[#141414] responsive";
    this.stylingTrComp = "p-[0.35em] border-b border-solid text-dark";
    this.stylingThComp =
      "p-[0.625em] text-end w-[958px] pb-2 pt-5 whitespace-pre";
    this.stylingTrBodyComp = "text-base ";
    this.stylingTheadComp =
      "text-base sticky top-0 z-50 bg-primary2 max-lg:hidden text-dark";
    this.stylingTBodyComp = "text-base ";
    this.stylingTdComp =
      "p-[0.625em] text-start lg:w-[220px] lg:table-cell flex justify-between z-0 font-normal";
  }

  /**
   *
   * @param cell
   * @condition if cell == refund return the menu for refunding
   * @returns
   */
  public override tdComp(cell: any) {
   

    if (cell?.column?.Header === "Id") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] whitespace-pre text-start !hidden lg:w-[180px] lg:table-cell justify-between font-medium"
        >
          {cell.render("Cell")}
        </td>
      );
    }

    if (cell?.column?.Header === "Title") {
      return (
        <td
          data-label={cell?.column?.Header}
          // className="p-[0.625em] text-start lg:w-[655px] whitespace-pre font-normal truncate line-clamp-2"
          className=" text-start lg:w-[70px] font-normal"
        >
          {cell.render("Cell")}
        </td>
      );
    }

    if (cell?.column?.Header === "Edit/Delete") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-end flex flex-row gap-2 whitespace-pre font-normal"
        >
          <EditPageButtonLink productId={cell?.row?.values?._id} cell={cell} />

         <DeleteLink entityType="article" entityData={cell?.row?.values?._id} />
        </td>
      );
    }

    if (cell?.column?.Header === "Wholesaler Price (AED)") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-end lg:w-[655px] whitespace-pre font-normal"
        >
          {cell.render("Cell")}
        </td>
      );
    } else {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-start lg:w-[655px] whitespace-pre font-normal"
        >
          {/* {cell.render("Cell")} */}
        </td>
      );
    }
  }

  public override thComp(column: any) {
    if (column?.Header === "Title") {
      return (
        <th
          key={uuidv4()}
          className="pb-2 pt-5 p-[0.625em] text-start lg:w-[655px] whitespace-pre"
        >
          <div className="flex items-center justify-start gap-2">
            <span>{column.render("Header")}</span>
          </div>
        </th>
      );
    } else if (column?.Header === "Edit/Delete") {
      return (
        <th key={uuidv4()} className={`${this.stylingThComp} lg:w-[180px] `}>
        <div className="flex items-end gap-2 justify-end">
          <span>{column.render("Header")}</span>{" "}
        </div>
      </th>
      );
    } else {
      return (
        <th key={uuidv4()} className={this.stylingThComp}>
          {/* {column.render("Header")} */}
        </th>
      );
    }
  }

  public override tableComp() {
    return (
      <div className="w-full lg:px-8 px-4">
        {/* <div className="flex justify-between lg:flex-row flex-col items-start my-4 shadow-tableShadow gap-2 pr-10 p-2.5 max-lg:pr-2.5"> */}
        <FilteredDataProvider />
        {/* </div> */}

        <div className="shadow-tableShadow bg-primary2">
          <div className="lg:px-6 px-5 pb-4 w-full overflow-scroll rounded mxs:h-[calc(100vh-257px)] h-[calc(124vh-257px)] max-lg:pr-1 main-table">
            <table
              {...this.getTableProps()}
              className={`${this.stylingTableComp} border-collapse border-spacing-3`}
            >
              {this.theadComp()}
              {/* <Divider className='w-full'/> */}

              {this.tBodyComp()}
            </table>
          </div>
        </div>

        <div className="mx-0">
          <Pagination initialLoad={true} jwtToken={this.props.jwtToken} />
        </div>
      </div>
    );
  }
}

export { TransactionTable };
